import React, { useContext, useMemo } from "react";
import style from "./index.module.scss";
import { Alert, Empty, Input, Modal, Spin } from "antd";
import { NewRuleModelParams } from "../../../../../service/score";
import TableBody from "./Components/TableBody";
import { ModalProps } from "antd/lib/modal";
import TableHeadTip from "./Components/TableHeadTip";
import ScoreContext from "../../RulesSetting/context";
import config from "../../../../../config";
import FileItem from "../../../../../components/FileItem";
import lodash from "lodash-es";
import AddSc from "../../RulesSetting/Components/AddSc";
const { TextArea } = Input;

interface CourseRulesForStudentModalProps extends ModalProps {
    courseNo: string;
    courseSeq: string;
}

const Index = ({
    courseNo,
    courseSeq,
    ...resProps
}: CourseRulesForStudentModalProps) => {
    const { prevData } = useContext(ScoreContext);

    //筛选出权重不为0的数据
    const filterData = (data: NewRuleModelParams[]) => {
        if (!data.length) return [];
        return data.filter(item => item.weight !== 0);
    };

    const nowWeight = useMemo(() => {
        return {
            dai: lodash.sumBy(prevData?.dailyGradeRuleModel, "weight"),
            fin: lodash.sumBy(prevData?.finalGradeRuleModel, "weight")
        };
    }, [prevData]);

    return (
        <Modal
            width={1200}
            title="预览"
            className={style.root}
            centered
            footer={null}
            {...resProps}>
            <Spin spinning={false}>
                <div className={style.over}>
                    {prevData?.filePath && (
                        <a
                            href={`${config.QiNiuDownloadUrl}/${prevData.filePath}?attname=${prevData.fileName}`}
                            target="_blank"
                            className={style.label}>
                            <FileItem
                                text={prevData?.fileName}
                                fileType={prevData?.fileType}
                            />
                        </a>
                    )}

                    <div className={style.table} style={{ marginTop: 15 }}>
                        <TableHeadTip title="考核规则" />
                        <p style={{ padding: 15 }}>{prevData?.description}</p>
                    </div>
                    <div className={style.table}>
                        <TableHeadTip
                            title="平时成绩"
                            percent={prevData?.dailyGrade || 0}
                        />

                        {prevData && nowWeight?.dai > prevData?.dailyGrade && (
                            <Alert
                                style={{ marginTop: 15 }}
                                type="warning"
                                message={`请调整表单项,目前小记${nowWeight?.dai},应为${prevData?.dailyGrade}`}
                            />
                        )}

                        <TableBody
                            list={filterData(
                                prevData?.dailyGradeRuleModel || []
                            )}
                            ruleCourseName="平时成绩"
                        />
                    </div>
                    <div className={style.table} style={{ marginTop: 20 }}>
                        <TableHeadTip
                            title="期末成绩"
                            percent={prevData?.finalGrade || 0}
                        />

                        {prevData && nowWeight?.fin > prevData?.finalGrade && (
                            <Alert
                                style={{ marginTop: 15 }}
                                type="warning"
                                message={`请调整表单项,目前小记${nowWeight?.fin},应为${prevData?.finalGrade}`}
                            />
                        )}

                        <TableBody
                            list={filterData(
                                prevData?.finalGradeRuleModel || []
                            )}
                            ruleCourseName="期末成绩"
                        />
                    </div>
                    <div className={style.table} style={{ marginTop: 20 }}>
                        <TableHeadTip title="额外加分" />
                        <div style={{ padding: 30 }}>
                            {!prevData?.extraRule && (
                                <Empty description="此课程未设置额外加分" />
                            )}
                            {prevData?.extraRule && (
                                <AddSc
                                    disabled
                                    extraRule={prevData.extraRule}
                                    expSwitch
                                />
                            )}
                        </div>
                    </div>
                </div>
            </Spin>
        </Modal>
    );
};

export default Index;
